var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCFlatSeatUnavailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d9d9",
  d: "M19 0H5a5 5 0 0 0-5 5v23h24V5a5 5 0 0 0-5-5"
})));
export { SvgCFlatSeatUnavailable as ReactComponent };